import QCMetadataTable from './QCMetadataTable';
export default QCMetadataTable;
